import axios from "axios";

export const getSendSign = (data, resp, error) => {
    axios.get(process.env.REACT_APP_SIGNFOROTHERS, { withCredentials: process.env.REACT_APP_CREDENTIALS, params: data })
      .then((res) => {
            resp(res);
        })
        .catch((err) => {
            error(err);
        });
};

export const getAuditLogs = (data, resp, error) => {
    axios.get(process.env.REACT_APP_AUDIT_LOGS, { withCredentials: process.env.REACT_APP_CREDENTIALS, params: data })
      .then((res) => {
            resp(res);
        })
        .catch((err) => {
            error(err);
        });
};